
/*
 *
 * Date: 2025
 * Description: Initial page for the application's first view
 * Author: Philippe Leroux @SKITSC
 *
 */


// Modules
import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";
import { Link } from "react-router-dom";

// Interfaces
import { i_initial_props } from "../interfaces/utility.interface";

const Splash = ( props : i_initial_props ) : ReactElement => {

    return (
        <Box sx={{ height : '100vh', backgroundImage : "url('/img/bg0.png')" , backgroundSize : 'cover' , backgroundPosition : 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', position: 'relative', '&::before': { content: '""', position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: 1 } }}>
            <Box sx={{ zIndex: 2, textAlign: 'center', maxWidth: '800px', padding: '0 20px', animation: 'fadeInUp 1s ease-out' }}>
                <Typography sx={{ color: 'white', fontSize: { xs: 32, md: 48 }, fontWeight: 800, marginBottom: '20px', textShadow: '2px 2px 4px rgba(0,0,0,0.7)', letterSpacing: '1px' }}> Parts Master </Typography>
                <Typography sx={{ color: 'white', fontSize: { xs: 18, md: 24 }, fontWeight: 500, marginBottom: '30px', textShadow: '1px 1px 2px rgba(0,0,0,0.7)', lineHeight: 1.4 }}>
                    Your Ultimate Destination for <strong>Competitive</strong> & <strong>Affordable</strong> Car Parts
                </Typography>
                <Typography sx={{ color: '#FFD700', fontSize: { xs: 16, md: 18 }, fontWeight: 600, marginBottom: '40px', textShadow: '1px 1px 2px rgba(0,0,0,0.7)' }}>
                     Find Better Deals • Compare Prices • Shop Smart 
                </Typography>
                <Box component={Link} to={'/login'} sx={{ display: 'inline-block', backgroundColor: '#FF6B35', color: 'white', padding: '15px 40px', fontSize: { xs: 18, md: 20 }, fontWeight: 700, textDecoration: 'none', borderRadius: '50px', textTransform: 'uppercase', letterSpacing: '1px', boxShadow: '0 8px 20px rgba(255, 107, 53, 0.4)', transition: 'all 0.3s ease', border: '2px solid transparent', '&:hover': { backgroundColor: 'transparent', border: '2px solid #FF6B35', color: '#FF6B35', transform: 'translateY(-2px)', boxShadow: '0 12px 25px rgba(255, 107, 53, 0.6)' } }} >
                    Get Started Now
                </Box>
            </Box>
            <Box sx={{ position: 'absolute', bottom: '20px', left: '50%', color: 'rgba(255, 255, 255, 0.8)', transform: 'translateX(-50%)', zIndex: 2, textAlign: 'center' }}>
                <Typography sx={{ fontSize: 14, textShadow: '1px 1px 2px rgba(0,0,0,0.7)' }}>
                    Powered by <strong>Xykal</strong> &copy; 2025
                </Typography>
            </Box>

            <style>
                {`
                    @keyframes fadeInUp {
                        from {
                            opacity: 0;
                            transform: translateY(30px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                `}
            </style>
        </Box>
    )
}

export default Splash;
